import * as React from 'react'
import { useState, useEffect, useRef, forwardRef, useCallback } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { Box, SxProps } from '@mui/material'
import { Container } from '@mui/material'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import authService from 'components/api-authorization/AuthorizeService'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import { useAppSelector, useAppDispatch } from 'shared/hooks'
import { selectDrawerOpen, selectMainBarSettings, selectTitle, setDrawerOpen } from 'store/applicationSlice'
import { ApplicationMainBarProfile } from './ApplicationMainBarProfile'
import { LogoIcon } from 'shared/icons/LogoIcon'
import type { User } from 'shared/types'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { useMainToolbar } from '../../contexts/MainToolbarContext'

interface ApplicationMainBarProps {

}

export const ApplicationMainBar = forwardRef((props: ApplicationMainBarProps, ref: any) => {
    //const drawerOpen = useAppSelector(selectDrawerOpen)
    //const title = useAppSelector(selectTitle)
    //const mainBarSettings = useAppSelector(selectMainBarSettings)
    //const dispatch = useAppDispatch()
    //const location = useLocation()
    //const navigate = useNavigate()
    //const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
    //const [user, setUser] = useState<User | undefined>(undefined)
    //const [subscription, setSubscription] = useState<number | undefined>(undefined)

    //const fetchData = async () => {
    //    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    //    setIsAuthenticated(isAuthenticated);
    //    setUser(user);
    //}

    //useEffect(() => {
    //    const subscriptionId = authService.subscribe(() => fetchData())
    //    setSubscription(subscriptionId)
    //    fetchData()
    //}, []);

    //const handleDrawerToggle = () => {
    //    dispatch(setDrawerOpen(!drawerOpen))
    //}

    //const [isStandaloneforAndroid, setIsStandaloneforAndroid] = useState<boolean>(window.matchMedia('(display-mode: standalone)').matches);
    //// @ts-ignore
    //const [isStandaloneforIOS, setIsStandaloneforIOS] = useState<boolean>(window.navigator.standalone !== undefined && window.navigator.standalone === true);


    //window.addEventListener("resize", () => {
    //    setIsStandaloneforAndroid(window.matchMedia('(display-mode: standalone)').matches);
    //    // @ts-ignore
    //    setIsStandaloneforIOS(window.navigator.standalone !== undefined && window.navigator.standalone === true)
    //});

    //const renderInstallButton = () => {
    //    if (isStandaloneforIOS || isStandaloneforAndroid) {
    //        return ('');
    //    }

    //    return (
    //        <Link to="/install/instruction">
    //            How To Install
    //        </Link>
    //    )
    //}

    //const styleButtonsContainer = {
    //    display: 'flex',
    //    gap: '20px',
    //    alignItems: 'center'
    //}


    //const installstyleButtonContainer = {
    //    display: {
    //        xs: 'none',
    //        md: 'flex'
    //    },
    //    gap: '20px',
    //    alignItems: 'center'
    //}

    //const handleBackClick = () => {
    //    if (mainBarSettings === undefined || mainBarSettings.back === undefined) {
    //        return
    //    }

    //    if (mainBarSettings.back.url !== undefined) {
    //        navigate(mainBarSettings.back.url)
    //        return
    //    }

    //    if (mainBarSettings.back.toParent === true) {
    //        navigate(-1)
    //        return
    //    }



    //}

    //const titleStyle: SxProps = {
    //    fontSize: '24px',
    //    color: '#000',
    //    fontWeight: '600',
    //    justifySelf:'center'
    //}

    //const childRoutesToolbarContentContainerStyle: SxProps = {
    //    flexGrow: 1,
    //    display: 'grid',
    //    gridTemplateColumns: '52px 6fr 52px',
    //    justifyContent: {
    //        xs: 'center',
    //        md: 'left',
    //    }
    //}

    //const childRoutesButtonsContainerStyle: SxProps = {
    //    display: 'flex',
    //    gap: '20px',
    //    alignItems: 'center',
    //    justifySelf: 'end',
    //}




    //const renderToolbar = () => {
    //    const renderStart = () => {
    //        if (mainBarSettings === undefined || mainBarSettings.showHamburgerButton === true) {
    //            return (
    //                <IconButton
    //                    color="inherit"
    //                    aria-label="open drawer"
    //                    edge="start"
    //                    onClick={handleDrawerToggle}
    //                    sx={{ margin: 0, display: { sm: 'none' } }}
    //                >
    //                    <MenuIcon sx={{ color: '#000' }} />
    //                </IconButton>
    //            )
    //        }


    //        if (mainBarSettings === undefined || mainBarSettings.back === undefined) {
    //            return ('')
    //        }

    //        return (
    //            <IconButton
    //                color="inherit"
    //                onClick={handleBackClick}
    //                size="large"
    //            >
    //                <ArrowBackIosIcon sx={{ color: '#000' }} />
    //            </IconButton>
    //        )
    //    }

    //    const renderCenterBlock = () => {
    //        if (mainBarSettings === undefined || mainBarSettings.title === undefined) {
    //            return (
    //                <Box sx={
    //                    {
    //                        flexGrow: 1,
    //                        display: 'flex',
    //                        justifyContent: {
    //                            xs: 'center',
    //                            md: 'left',
    //                        }
    //                    }
    //                }>
    //                <Typography component="div" sx={
    //                    {
    //                        maxWidth: '285px',
    //                        px: '20px'
    //                    }
    //                }
    //                >
    //                    <Link to='/'>
    //                        <LogoIcon sx={{
    //                            width: '100%',
    //                            height: 'auto'
    //                        }} />
    //                    </Link>
    //                    </Typography>
    //                </Box>
    //            )
    //        }

    //        if (mainBarSettings?.sections?.center?.content) {
    //            return (
    //                <div>
    //                    {mainBarSettings?.sections?.center?.content}
    //                </div>
    //            )
    //        }

    //        return (
    //            <Box sx={titleStyle}>
    //                {mainBarSettings.title ? mainBarSettings.title : '' }
    //            </Box>
    //        )
    //    }

    //    const renderEndBlock = () => {
    //        if (mainBarSettings === undefined) {
    //            return (
    //                <ApplicationMainBarProfile></ApplicationMainBarProfile>
    //            )
    //        }

    //        if (mainBarSettings.showProfileButton === undefined
    //            || mainBarSettings.showProfileButton === false){
    //            return (``)
    //        }

    //        return (
    //            <ApplicationMainBarProfile></ApplicationMainBarProfile>
    //        )
    //    }




    //    return (
    //        <Toolbar disableGutters sx={childRoutesToolbarContentContainerStyle}>
    //            <Box >
    //                {
    //                    renderStart()
    //                }
    //            </Box>
    //            <Box sx={titleStyle}>
    //                {
    //                    renderCenterBlock()
    //                }
    //            </Box>
    //            <Box sx={childRoutesButtonsContainerStyle}>
    //                {
    //                    renderEndBlock()
    //                }
    //            </Box>
    //        </Toolbar>
    //    )
    //}


    //const appBarRef = useRef<HTMLElement>(null);
    //const [mode, setMode] = useState<any>(false)

    //useEffect(() => {
    //    console.log(appBarRef)
    //}, [
    //    appBarRef
    //])

    //const handleButtonClick = (event: any) => {

    //}
    const { toolbarContent } = useMainToolbar()

    return (
        <AppBar
            position="fixed"
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: "#FFF", py: '10px' }}
        >
            <Container
                maxWidth={false}
                sx={{ padding: '0' }}
            >
                {toolbarContent}
            </Container>
        </AppBar>
    )
})
